import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AdministratorCreateForm } from '../components';
import Spin from 'antd/lib/spin';
import { createAdministratorActions } from '../../../features/account-management/ducks';
import { apiCallIds } from '../../../features/account-management/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';

const mapStateToProps = state => ({
  isCreating: selectIsInProgress(state, apiCallIds.CREATE_ADMINISTRATOR),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createAdministrator: createAdministratorActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AdministratorCreateContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    isCreating: PropTypes.bool.isRequired,
  };

  onSubmit = accountData => {
    this.props.actions.createAdministrator({ accountData });
  };

  render() {
    const { isCreating } = this.props;

    return (
      <Spin spinning={isCreating}>
        <AdministratorCreateForm onSubmit={this.onSubmit} />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/administrator-management/containers/AdministratorCreateContainer.js